module.exports = __webpack_public_path__ + "img/login.98a496ef.jpg";